<app-otp
  [displayOtpDialog]="true"
  [event]="'change-password'"
  [countDownStarted]="countDownStarted"
  [resendDelaySeconds]="resendDelaySeconds"
  [twoFactorAuthMethod]="twoFactorAuthMethod"
  (isOtpComplete)="onOtpComplete($event)"
  mode="inline"
>
</app-otp>
